function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg020Namibia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#496E2D"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#496E2D"
    },
    points: "449.016,0.009 449.025,0 401.81,0 401.802,0.009  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "401.81,0 0,0 0,401.81 401.802,0.009 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "203.694,139.124 169.583,155.168 187.747,188.203 150.708,181.118 146.015,218.534   120.215,191.014 94.416,218.534 89.724,181.118 52.685,188.201 70.847,155.167 36.738,139.124 70.849,123.079 52.685,90.045   89.722,97.13 94.417,59.714 120.215,87.234 146.016,59.714 150.708,97.13 187.748,90.045 169.584,123.08 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "512,0.004 512,110.196 110.202,511.993 0,511.993 0,401.813 401.798,0.016 449.013,0.016   449.024,0.004 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A2001D"
    },
    points: "62.967,511.996 512,62.978 512,0.004 449.025,0.004 449.016,0.013 0,449.044 0,511.996 "
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg020Namibia);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPGc+Cgk8cmVjdCBzdHlsZT0iZmlsbDojNDk2RTJEOyIgd2lkdGg9IjUxMiIgaGVpZ2h0PSI1MTIiLz4KCTxwb2x5Z29uIHN0eWxlPSJmaWxsOiM0OTZFMkQ7IiBwb2ludHM9IjQ0OS4wMTYsMC4wMDkgNDQ5LjAyNSwwIDQwMS44MSwwIDQwMS44MDIsMC4wMDkgICIvPgo8L2c+Cjxwb2x5Z29uIHN0eWxlPSJmaWxsOiMwMDUyQjQ7IiBwb2ludHM9IjQwMS44MSwwIDAsMCAwLDQwMS44MSA0MDEuODAyLDAuMDA5ICIvPgo8cG9seWdvbiBzdHlsZT0iZmlsbDojRkZEQTQ0OyIgcG9pbnRzPSIyMDMuNjk0LDEzOS4xMjQgMTY5LjU4MywxNTUuMTY4IDE4Ny43NDcsMTg4LjIwMyAxNTAuNzA4LDE4MS4xMTggMTQ2LjAxNSwyMTguNTM0ICAgMTIwLjIxNSwxOTEuMDE0IDk0LjQxNiwyMTguNTM0IDg5LjcyNCwxODEuMTE4IDUyLjY4NSwxODguMjAxIDcwLjg0NywxNTUuMTY3IDM2LjczOCwxMzkuMTI0IDcwLjg0OSwxMjMuMDc5IDUyLjY4NSw5MC4wNDUgICA4OS43MjIsOTcuMTMgOTQuNDE3LDU5LjcxNCAxMjAuMjE1LDg3LjIzNCAxNDYuMDE2LDU5LjcxNCAxNTAuNzA4LDk3LjEzIDE4Ny43NDgsOTAuMDQ1IDE2OS41ODQsMTIzLjA4ICIvPgo8cG9seWdvbiBzdHlsZT0iZmlsbDojRjBGMEYwOyIgcG9pbnRzPSI1MTIsMC4wMDQgNTEyLDExMC4xOTYgMTEwLjIwMiw1MTEuOTkzIDAsNTExLjk5MyAwLDQwMS44MTMgNDAxLjc5OCwwLjAxNiA0NDkuMDEzLDAuMDE2ICAgNDQ5LjAyNCwwLjAwNCAiLz4KPHBvbHlnb24gc3R5bGU9ImZpbGw6I0EyMDAxRDsiIHBvaW50cz0iNjIuOTY3LDUxMS45OTYgNTEyLDYyLjk3OCA1MTIsMC4wMDQgNDQ5LjAyNSwwLjAwNCA0NDkuMDE2LDAuMDEzIDAsNDQ5LjA0NCAwLDUxMS45OTYgIi8+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };